/* eslint-disable @typescript-eslint/no-explicit-any */
import { ai } from '@sekoia/shared/utils/telemetryService';

const GetSessionId = () => {
  return ai.getSessionId();
};

export const getSessionId = GetSessionId;
